// extracted by mini-css-extract-plugin
export default {"button":"StandardButton_button__vFfhV","green":"StandardButton_green__2lCIB","blue":"StandardButton_blue__BTZ7P"};